/**
 * Render option explanations as plain text (admin-style):
 * keep line breaks, strip HTML tags / markup.
 */
export function formatPlainExplanation(text) {
  if (text == null) return '';
  let s = String(text);
  s = s.replace(/<\s*br\s*\/?\s*>/gi, '\n');
  s = s.replace(/<\/\s*(p|div|li|h[1-6]|tr)\s*>/gi, '\n');
  s = s.replace(/<\s*li[^>]*>/gi, '• ');
  s = s.replace(/<[^>]+>/g, '');
  s = s
    .replace(/&nbsp;/gi, ' ')
    .replace(/&#160;/gi, ' ')
    .replace(/\u00A0/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&apos;/g, "'");
  s = s.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  s = s.replace(/[ \t]+\n/g, '\n');
  s = s.replace(/^\n+|\n+$/g, '');
  return s;
}

/** Render explanations with basic inline styling from Excel import (bold, italic, underline, breaks). */
export function formatExplanationHtml(text) {
  if (text == null) return '';
  let s = String(text);
  s = s.replace(/<\s*br\s*\/?\s*>/gi, '\n');
  s = s.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  // Non-breaking spaces prevent wrapping and break option layout
  s = s.replace(/&nbsp;/gi, ' ');
  s = s.replace(/&#160;/gi, ' ');
  s = s.replace(/\u00A0/g, ' ');
  // Normalize allowed inline tags to lowercase, drop attributes
  s = s.replace(/<\s*(strong|b|em|i|u)(?:\s[^>]*)?\s*>/gi, (_, tag) => `<${tag.toLowerCase()}>`);
  s = s.replace(/<\s*\/\s*(strong|b|em|i|u)\s*>/gi, (_, tag) => `</${tag.toLowerCase()}>`);
  // Drop empty inline tags (whitespace / nested empties only)
  let prev;
  do {
    prev = s;
    s = s.replace(/<strong>(?:[\s\u200B\uFEFF]|<br>)*<\/strong>/gi, '');
    s = s.replace(/<b>(?:[\s\u200B\uFEFF]|<br>)*<\/b>/gi, '');
    s = s.replace(/<em>(?:[\s\u200B\uFEFF]|<br>)*<\/em>/gi, '');
    s = s.replace(/<i>(?:[\s\u200B\uFEFF]|<br>)*<\/i>/gi, '');
    s = s.replace(/<u>(?:[\s\u200B\uFEFF]|<br>)*<\/u>/gi, '');
  } while (s !== prev);
  // Drop empty leading/trailing lines so we don't emit orphan <br>
  s = s.replace(/^\n+|\n+$/g, '');
  s = s.replace(/\n/g, '<br>');
  // Strip any remaining disallowed tags
  s = s.replace(/<(?!\/?(?:strong|b|em|i|u|br)\b)[^>]+>/gi, '');
  // Remove empty tags again (in case strip left shells) + trailing <br>
  do {
    prev = s;
    s = s.replace(/<strong>(?:[\s\u200B\uFEFF]|<br>)*<\/strong>/gi, '');
    s = s.replace(/<b>(?:[\s\u200B\uFEFF]|<br>)*<\/b>/gi, '');
    s = s.replace(/<em>(?:[\s\u200B\uFEFF]|<br>)*<\/em>/gi, '');
    s = s.replace(/<i>(?:[\s\u200B\uFEFF]|<br>)*<\/i>/gi, '');
    s = s.replace(/<u>(?:[\s\u200B\uFEFF]|<br>)*<\/u>/gi, '');
    s = s.replace(/(?:<br>\s*)+$/gi, '');
    s = s.replace(/^(?:\s|<br>)+/gi, '');
  } while (s !== prev);
  return s;
}
